import {
  takeLatest, call, put,
} from 'redux-saga/effects';
import api from '../../api/index';
import {
  GET_SAGEMAKER_URL, SET_SAGEMAKER_URL, SAGEMAKER_URL_REQUEST_FAILED, SENDING_SAGEMAKER_URL_REQUEST, SET_SAGEMAKER_URL_EXIST,
} from '../../types/Types';

/**
 * Call the api and dispatch data to the reducer
 * @param { Object } action Contained object data to be send to API call
 */
export function* getSageMakerURL(action) {
  const { data, requestType } = action;
  try {
    yield put({
      type: SENDING_SAGEMAKER_URL_REQUEST,
      sageMakerURLData: '',
      isSMSending: true,
      isSMURLSuccess: false,
      smUrlError: false,
      isSageMakerUrlExist: true,
    });
    const response = yield call(api.dashboard.getSageMakerUrl, data);
    if (response) {
      if (requestType === 'load') {
        yield put({
          type: SET_SAGEMAKER_URL_EXIST,
          sageMakerURLData: '',
          isSMSending: false,
          smUrlError: false,
          isSMURLSuccess: true,
          isSageMakerUrlExist: true,
        });
      } else {
        yield put({
          type: SET_SAGEMAKER_URL,
          sageMakerURLData: response.AuthorizedUrl,
          isSMSending: false,
          smUrlError: false,
          isSMURLSuccess: true,
          isSageMakerUrlExist: true,
        });
      }
    } else {
      yield put({
        type: SAGEMAKER_URL_REQUEST_FAILED,
        sageMakerURLData: null,
        isSMSending: false,
        smUrlError: true,
        isSMURLSuccess: false,
        isSageMakerUrlExist: false,
        fMsg: '',
      });
    }
  } catch (e) {
    yield put({
      type: SAGEMAKER_URL_REQUEST_FAILED,
      fMsg: e.message,
      isSMSending: false,
      smUrlError: true,
      isSMURLSuccess: false,
      sageMakerURLData: null,
      isSageMakerUrlExist: false,
    });
  }
}

/**
 * map the dispatched action to the above function
 */
export default function* watchGetSageMakerURL() {
  yield takeLatest(GET_SAGEMAKER_URL, getSageMakerURL);
}
